import styled from "@emotion/styled";
import { Container, FlexRow, List, TagLink, Text } from "atoms";

type HomeTagsProps = {
  tags: [string, React.ComponentProps<typeof TagLink>["variant"]][];
};

function HomeTagListBlock({ tags }: HomeTagsProps) {
  return (
    <Wrapper id="homeTags">
      <Container width="lg" style={{ position: "relative" }}>
        <SideScrollContainer>
          <TagFlexRow flexWrap="nowrap">
            <Text size="xs" bold font="display" textTransform="uppercase">
              Celebrate <br />
              Diverse Creators
            </Text>
            <TagList type="blank">
              {tags.map(([label, bg]) => (
                <li key={label}>
                  <HomeTagLink
                    tag={label}
                    variant={bg}
                    analyticsLocation="HomeHeader"
                  />
                </li>
              ))}
            </TagList>
          </TagFlexRow>
        </SideScrollContainer>
      </Container>
    </Wrapper>
  );
}
const Wrapper = styled.section(({ theme }) => ({
  backgroundColor: theme.colors.fg,
  color: theme.colors.bg,
  // hides scrollbar
  height: 62,
  overflow: "hidden",
}));
const SideScrollContainer = styled.div(({ theme }) => ({
  margin: `0 calc(${theme.spacing.gutter} * -1)`,
  overflowX: "scroll",
  overflowY: "hidden",
  paddingBottom: 30,
  msOverflowStyle: "none" /* IE 11 */,
  scrollbarWidth: "none" /* Firefox 64 */,
  "html body &::WebkitScrollbar": {
    height: "0 !important",
  },
  /* Track */
  "html body &::WebkitScrollbarTrack": {
    backgroundColor: "rgb(255 255 255 / 0)",
    height: "0 !important",
  },
  /* Handle */
  "html body &::WebkitScrollbarThumb": {
    backgroundColor: "rgb(255 255 255 / 0)",
    height: "0 !important",
  },
  /* Handle on hover */
  "html body &::WebkitScrollbarThumb:hover": {
    backgroundColor: "rgb(255 255 255 / 0)",
    height: "0 !important",
  },
  "&::before,&::after": {
    content: "''",
    display: "block",
    position: "absolute",
    top: 0,
    right: 0,
    bottom: "0.9rem",
    width: theme.spacing.gutter,
    backgroundImage: `linear-gradient( to right, rgb(255 255 255 / 0) 0%, ${theme.colors.fg} 90%)`,
    zIndex: 2,
    pointerEvents: "none",
  },

  "&::before": {
    right: "auto",
    left: 0,
    backgroundImage: `linear-gradient( to left, rgb(255 255 255 / 0) 0%, ${theme.colors.fg} 90%)`,
  },
}));

const TagFlexRow = styled(FlexRow)(({ theme }) => ({
  padding: `1rem ${theme.spacing.gutter}`,
  // margin: "0 0 calc(var(--scrollbarSize) * -1) 0",
  alignItems: "center",
  minWidth: "100%",
  width: "max-content",
  position: "relative",
  zIndex: 1,
  p: {
    lineHeight: 1.2,
    margin: 0,
    fontSize: theme.fontSizes.xxxs,
    [theme.breakpoints.desktopMedium]: {
      fontSize: theme.fontSizes.xxs,
    },
  },
  [theme.breakpoints.tablet]: {
    br: {
      display: "none",
    },
  },
  [theme.breakpoints.desktopMedium]: {
    // padding: "1rem 0",
  },
}));

const TagList = styled(List)(({ theme }) => ({
  display: "flex",
  flexWrap: "nowrap",
  gap: 10,
  whiteSpace: "nowrap",
  paddingRight: theme.spacing.gutter,
  li: {
    display: "flex",
    alignItems: "center",
  },
  [theme.breakpoints.tablet]: {
    paddingRight: 0,
  },
  [theme.breakpoints.desktopMedium]: {
    paddingLeft: "1rem",
    flex: "1 !important",
    justifyContent: "space-between",
  },
}));

const HomeTagLink = styled(TagLink)(({ theme }) => ({
  span: {
    color: theme.colors.white,
    backgroundColor: theme.colors.black,
    borderColor: theme.colors.bg60,
    fontSize: theme.fontSizes.xxs,
  },
  "&&:hover span, &&:focus span": {
    borderColor: theme.colors.bg,
  },
}));

export { HomeTagListBlock };
